export const DOWNLOADS_MANIFEST_URL = "https://apps.datacenterwest.com/downloads/manifest.json";
export const DOWNLOADS_PAGE_URL = "https://apps.datacenterwest.com/downloads.php";
/** Compare dotted version strings (e.g. 1.0.0 vs 1.0.1). */
export function compareVersions(left, right) {
    const leftParts = left.split(".").map((part) => Number.parseInt(part, 10) || 0);
    const rightParts = right.split(".").map((part) => Number.parseInt(part, 10) || 0);
    const length = Math.max(leftParts.length, rightParts.length);
    for (let index = 0; index < length; index += 1) {
        const diff = (leftParts[index] ?? 0) - (rightParts[index] ?? 0);
        if (diff !== 0) {
            return diff;
        }
    }
    return 0;
}
export async function fetchLatestReleaseVersion() {
    try {
        const response = await fetch(DOWNLOADS_MANIFEST_URL, { cache: "no-store" });
        if (!response.ok) {
            return null;
        }
        const data = (await response.json());
        return data.version ?? null;
    }
    catch {
        return null;
    }
}
export async function findNewerReleaseVersion(installedVersion) {
    const latestVersion = await fetchLatestReleaseVersion();
    if (!latestVersion) {
        return null;
    }
    return compareVersions(latestVersion, installedVersion) > 0 ? latestVersion : null;
}
